import { Component, OnInit, OnDestroy } from "@angular/core";
import { CrudService } from "src/app/services/crud.service";
import { UtilService } from "src/app/services/util.service";
import { LoadingController, AlertController, Platform } from "@ionic/angular";
import { AuthService } from "src/app/services/auth.service";
import { Router } from "@angular/router";
import { Capacitor } from "@capacitor/core";

@Component({
    selector: "app-seller-registration",
    templateUrl: "./seller-registration.html",
    styleUrls: ["./seller-registration.scss"],
    standalone: false
})
export class SellerRegistrationPage implements OnInit, OnDestroy {

  linkShare = '';

  constructor(
    private crud: CrudService,
    private util: UtilService,
    private loadCtrl: LoadingController,
    public alertController: AlertController,
    public route: Router,
    private platform: Platform,
    private auth: AuthService
  ) {}

  ngOnInit() {
    this.crud.getData('Link/seller-registration')
    .subscribe((response: any) => {
      this.linkShare = response.data.link;
    });
  }

  async shareLink() {
    const message = `Access my link and join GoSpread as a Spreader`;

    if (this.platform.is('mobileweb') || this.platform.is('pwa')) {
      window.open(`https://wa.me/?text=${message} ${this.linkShare}`, '_blank');
    } else if (navigator.share) {
      await navigator.share({
        title: "GoSpread - Spread",
        text: message,
        url: this.linkShare
      }).catch(console.error);
    } else {
      window.open(`https://wa.me/?text=${message} ${this.linkShare}`, '_blank');
    }
  }

  copyLink() {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(this.linkShare)
        .then(() => this.util.showToast("Link copied"))
        .catch(() => this.copyToClipboard(this.linkShare));
    } else {
      this.copyToClipboard(this.linkShare);
      this.util.showToast("Link copied");
    }
  }

  copyToClipboard(string) {
    let textarea;
    let result;

    try {
      textarea = document.createElement("textarea");
      textarea.setAttribute("readonly", true);
      textarea.setAttribute("contenteditable", true);
      textarea.style.position = "fixed";
      textarea.value = string;

      document.body.appendChild(textarea);

      textarea.focus();
      textarea.select();

      const range = document.createRange();
      range.selectNodeContents(textarea);

      const sel = window.getSelection();
      sel.removeAllRanges();
      sel.addRange(range);

      textarea.setSelectionRange(0, textarea.value.length);
      result = document.execCommand("copy");
    } catch (err) {
      console.error(err);
      result = null;
    } finally {
      document.body.removeChild(textarea);
    }

    if (!result) {
      const isMac = navigator.platform.toUpperCase().indexOf("MAC") >= 0;
      const copyHotkey = isMac ? "⌘C" : "CTRL+C";
      result = prompt(`Press ${copyHotkey}`, string);
      if (!result) {
        return false;
      }
    }
    return true;
  }

  ngOnDestroy() {}
}
